__turbopack_context__.v({
  "card": "AiInRecruitingTransformSection-module__ozp8_a__card",
  "cardClass": "AiInRecruitingTransformSection-module__ozp8_a__cardClass",
  "cardContent": "AiInRecruitingTransformSection-module__ozp8_a__cardContent",
  "cardDesc": "AiInRecruitingTransformSection-module__ozp8_a__cardDesc",
  "cardIcon": "AiInRecruitingTransformSection-module__ozp8_a__cardIcon",
  "cardPlain": "AiInRecruitingTransformSection-module__ozp8_a__cardPlain",
  "cardTitle": "AiInRecruitingTransformSection-module__ozp8_a__cardTitle",
  "numberCircle": "AiInRecruitingTransformSection-module__ozp8_a__numberCircle",
  "transformHead": "AiInRecruitingTransformSection-module__ozp8_a__transformHead",
  "transformSection": "AiInRecruitingTransformSection-module__ozp8_a__transformSection",
  "transformSubtitle": "AiInRecruitingTransformSection-module__ozp8_a__transformSubtitle",
  "transformTitle": "AiInRecruitingTransformSection-module__ozp8_a__transformTitle",
});
